import { Outlet } from "react-router";

export const Payments = () => {
  return <Outlet />;
};
